const locale = {
    placeholder: 'Chọn thời gian',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/vi_VN.tsx